import script from "./GeoDistributionInput.vue?vue&type=script&setup=true&lang=js"
export * from "./GeoDistributionInput.vue?vue&type=script&setup=true&lang=js"

import "./GeoDistributionInput.vue?vue&type=style&index=0&id=72a388d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a388d9"]])

export default __exports__